<div>
    <div style="display: block">
      <canvas baseChart height="250vh"
              [datasets]="chartData"
              [labels]="seriesLabels"
              [options]="options"
              [legend]="legend"
              [chartType]="type"
              >
      </canvas>
    </div>
  </div>
